import { useQuery } from '@apollo/react-hooks';
import gql from 'graphql-tag';
import { State } from '../../graphql/states.datatypes';

export interface StateData {
    stateByAbbreviation: State;
}

export const gqlState = `
    id,
    name,
    abbreviation,
    credit_card_fee {
        id,
        fee,
        type,
        type_id
    }
`;

export const GET_STATE_BY_ABBREVIATION = gql`
    query stateByAbbreviation($abbreviation: String!){
        stateByAbbreviation(abbreviation: $abbreviation){
            ${gqlState}
        }
    }
`;

export const getStateByAbbreviation = (abbreviation: string) => {
    return useQuery<StateData>(GET_STATE_BY_ABBREVIATION, {
        variables: { abbreviation }
    });
};

export default getStateByAbbreviation;
